module.exports = __webpack_public_path__ + "img/SVG6.47d71b93.svg";